import { observer } from 'mobx-react-lite'
import {
  EditScopeChangeCustomItem,
  ScopeChangeEditCustomItemsDialog,
} from '@/features/admin/scope-change-requests/ScopeChangeEditCustomItemsDialog'
import {
  type ScopeChangeEditCustomItemsDialogViewModel,
  type EditScopeChangeCustomItemViewModel,
} from './ScopeChangeEditCustomItemsDialogViewModel'

export interface ScopeChangeEditCustomItemsDialogContainerProps {
  vm: ScopeChangeEditCustomItemsDialogViewModel
}

export const ScopeChangeEditCustomItemsDialogContainer = observer(
  function ScopeChangeEditCustomItemsDialogContainer({
    vm,
  }: ScopeChangeEditCustomItemsDialogContainerProps) {
    return (
      <ScopeChangeEditCustomItemsDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onAddItem={vm.addScopeChange}
        onSave={vm.save}
        isSavePending={vm.save.pending}
      >
        {vm.editScopeChangeCustomItems.map((item) => {
          return (
            <EditScopeChangeCustomItemContainer
              key={item.key}
              item={item}
              onRemove={() => vm.removeScopeChange(item.key)}
            />
          )
        })}
      </ScopeChangeEditCustomItemsDialog>
    )
  },
)

interface EditScopeChangeCustomItemContainerProps {
  item: EditScopeChangeCustomItemViewModel
  onRemove: () => void
}

const EditScopeChangeCustomItemContainer = observer(
  function EditScopeChangeCustomItemContainer({
    item,
    onRemove,
  }: EditScopeChangeCustomItemContainerProps) {
    return (
      <EditScopeChangeCustomItem
        itemKey={item.key}
        name={item.name}
        nameError={item.validation.getError('name')}
        onNameChange={item.setName}
        quantity={item.quantity}
        quantityError={item.validation.getError('quantity')}
        onQuantityChange={item.setQuantity}
        onIncrementQuantity={item.incrementQuantity}
        onDecrementQuantity={item.decrementQuantity}
        onRemove={onRemove}
      />
    )
  },
)
